import React from 'react';
import classnames from 'classnames';

import Link from '../components/Link';
import Button from '../components/Button';

import WhatsappButtonIcon from './WhatsappButtonIcon';
import getButtonUrl from './getButtonUrl';

const WhatsappButton = () => (
  <Link
    href={getButtonUrl()}
    target="_blank"
    rel="noopener noreferrer"
  >
    <Button
      className={classnames(
        'w-12 h-12 lg:w-16 lg:h-16',
        'bg-green-400 text-white flex items-center justify-center rounded-full shadow-lg border-white',
        'hover:bg-gray-900 hover:border-gray-900 hover:text-green-400 hover:shadow-xl',
        'focus:outline-none',
      )}
    >
      <WhatsappButtonIcon />
    </Button>
  </Link>
);

export default WhatsappButton;
